var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import OutlinedButtonCheck from 'acud-icon/lib/icons/OutlinedButtonCheck';
import { lengthLimit } from '../_util/lengthLimit';
class ButtonCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = e => {
            const { disabled, onChange } = this.props;
            if (disabled) {
                return;
            }
            const curChecked = this.state.checked;
            if (!('checked' in this.props)) {
                this.setState({
                    checked: !curChecked
                });
            }
            if (onChange) {
                onChange({
                    target: Object.assign(Object.assign({}, this.props), { checked: !curChecked }),
                    stopPropagation() {
                        e.stopPropagation();
                    },
                    preventDefault() {
                        e.preventDefault();
                    },
                    nativeEvent: e.nativeEvent
                });
            }
        };
        const checked = 'checked' in props ? props.checked : props.defaultChecked;
        this.state = {
            checked
        };
    }
    static getDerivedStateFromProps(props, state) {
        if ('checked' in props) {
            return Object.assign(Object.assign({}, state), { checked: props.checked });
        }
        return null;
    }
    render() {
        const _a = this.props, { prefixCls, className, style, disabled, 
        // onClick,
        // value,
        children } = _a, others = __rest(_a, ["prefixCls", "className", "style", "disabled", "children"]);
        const title = typeof children === 'string' && children.length > 8
            ? children
            : undefined;
        const childrenFormat = typeof children === 'string'
            ? lengthLimit(children, 8)
            : children;
        const globalProps = Object.keys(others).reduce((prev, key) => {
            if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
                // eslint-disable-next-line no-param-reassign
                prev[key] = others[key];
            }
            return prev;
        }, {});
        const { checked } = this.state;
        const classString = classNames(prefixCls, className, {
            [`${prefixCls}-checked`]: checked,
            [`${prefixCls}-disabled`]: disabled
        });
        return (<span className={classString} style={style} aria-disabled={disabled} onClick={this.handleClick} {...globalProps} title={title}>
                {childrenFormat}
                {checked ? <span className={`${prefixCls}-checked-flag`}/> : null}
                {checked
                ? <OutlinedButtonCheck className={`${prefixCls}-checked-icon`} width={12} height={12}/>
                : null}
            </span>);
    }
}
ButtonCheckbox.defaultProps = {
    prefixCls: 'acud-checkbox-button',
    className: '',
    style: {},
    defaultChecked: false
};
export default ButtonCheckbox;
